<template lang="pug">
div
  .d-flex.justify-center.mt-6.mt-md-10.mb-5
    custom-title {{ title }}
  v-container.pb-10(v-if="!noContainer")
    slot
  .pb-10(v-else)
    slot
</template>

<script>
import CustomTitle from "@/components/others/CustomTitle";

export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    noContainer: {
      type: Boolean,
      default: false,
    },
    get: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    shareLink() {
      return this.server + location.pathname;
    },
    sm() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  created() {
    this.get.forEach((v) => this.$rest(v).get());
  },
  components: {
    CustomTitle,
  },
};
</script>
